/**
 * Created by 1 on 2017/8/25.
 */
'use strict';
const LoggerUtil = require('./LoggerUtil');
const CommonUtil = require('./CommonUtil');
const CRSTransformUtil = require('./CRSTransformUtil');
const GeometryUtil = require('./GeometryUtil');
const CoordUtil = require('./CoordUtil');
const GeoJSONUtil = require('./geojson/GeoJSONUtil');
const LayerUtil = require('./LayerUtil');
const ResourceUtil = require('./ResourceUtil');
const SpatialOPUtil = require('./SpatialOPUtil');
const RenderUtil = require('./RenderUtil');
const SymbolBuilder = require('./builder/SymbolBuilder');
const GeometryBuilder = require('./builder/GeometryBuilder');
const FeatureBuilder = require('./builder/FeatureBuilder');
/**
 * @namespace
 * @memberOf G
 * @description 工具包
 */
const utils = {
    LoggerUtil,
    CommonUtil,
    CRSTransformUtil,
    GeometryUtil,
    CoordUtil,
    GeoJSONUtil,
    LayerUtil,
    ResourceUtil,
    SpatialOPUtil,
    RenderUtil,
    SymbolBuilder,
    GeometryBuilder,
    FeatureBuilder
};
module.exports = utils;